import _ from "underscore";
import * as logger from "../../utils/logger";
import GpsMock from "../../utils/debug/gpsMock";
import { DataActions } from "../../store/data/actions";
import { MobileActions } from "../../store/mobile/actions";
import pageHTML from "./drivingSimulator.tmpl";
import DebugPageView from "./debugPageView";

export default class DrivingSimulatorView extends DebugPageView {
    private readonly template = _.template(pageHTML);
    private readonly drivingIterTimeout: any = null;
    private readonly originalAutoDriveFlag = window.DRIVE_DEBUG && window.DRIVE_DEBUG.DISABLE_AUTO_DRIVE_ACTIONS;
    private readonly gpsMock;
    private isSimDriving = false;
    private drivingTimeout: any = null;

    constructor (options) {
        super(options);

        this.storeUnsubscribe = this.app.store.subscribe(() => this.storeListener());
        this.gpsMock = new GpsMock(options.app.manager.movement);
    }

    /* eslint-disable @typescript-eslint/unbound-method */
    events () {
        return {
            "click #start": this.start,
            "click #stop": this.stop,
            "click #simulate": this.simulate
        } as Backbone.EventsHash;
    }
    /* eslint-enable @typescript-eslint/unbound-method */

    render () {
        this.el.innerHTML = this.template({
            isGpsMock: this.app.manager.movement.geolocation.mock
        });

        this.app.store.dispatch(MobileActions.setPageState({
            title: "Driving Simulator",
            pageLevel: 2
        }));

        return this;
    }

    startSimulatedDriving (drivingTime, stopTime) {
        this.isSimDriving = !this.isSimDriving;
        logger.event(logger.Event.MOTIONCHANGE, `SIMULATION: ${ this.isSimDriving }`);
        this.app.store.dispatch(DataActions.setDriving(this.isSimDriving));

        this.drivingTimeout = setTimeout(() => {
            this.startSimulatedDriving(drivingTime, stopTime);
        }, this.isSimDriving ? drivingTime : stopTime);
    }

    start () {
        if (window.DRIVE_DEBUG) {
            window.DRIVE_DEBUG.DISABLE_AUTO_DRIVE_ACTIONS = false;
        }

        let drivingDurationInput = <HTMLInputElement>document.getElementById("drivingDuration");
        let stoppedDurationInput = <HTMLInputElement>document.getElementById("stoppedDuration");
        let drivingDuration = drivingDurationInput.value;
        let stoppedDuration = stoppedDurationInput.value;

        if (drivingDuration && stoppedDuration) {
            let numbericDrivingDuration = parseInt(drivingDuration, 10);
            let numbericStoppedDuration = parseInt(stoppedDuration, 10);

            if (numbericDrivingDuration && numbericStoppedDuration) {
                this.startSimulatedDriving(numbericDrivingDuration * 1000, numbericStoppedDuration * 1000);
            }
        }
    }

    stop () {
        if (window.DRIVE_DEBUG) {
            window.DRIVE_DEBUG.DISABLE_AUTO_DRIVE_ACTIONS = this.originalAutoDriveFlag;
        }

        clearTimeout(this.drivingTimeout);
        clearTimeout(this.drivingIterTimeout);
        this.isSimDriving = false;
        logger.event(logger.Event.MOTIONCHANGE, `SIMULATION: Stopped`);
        this.app.store.dispatch(DataActions.setDriving(false));
    }

    storeListener() {
        let drivingStatusElement = <HTMLDivElement>document.getElementById("isSimulatedDriving");

        if (drivingStatusElement) {
            drivingStatusElement.textContent = this.app.store.getState().data.driving ? "YES" : "NO";
        }
    }

    simulate () {
        // Is the movement service in "MOCK" mode?
        if (!this.app.manager.movement.geolocation.mock) {
            if (window.DRIVE_DEBUG) {
                window.DRIVE_DEBUG.DISABLE_AUTO_DRIVE_ACTIONS = false;
            }

            let speedMocksCheckbox = <HTMLInputElement>document.getElementById("simulate-mock-speeds");
            let isChecked = speedMocksCheckbox.checked;
            this.gpsMock.initialize(isChecked);
        } else {
            if (window.DRIVE_DEBUG) {
                window.DRIVE_DEBUG.DISABLE_AUTO_DRIVE_ACTIONS = this.originalAutoDriveFlag;
            }

            this.gpsMock.shutdown();
        }

        this.render();
    }
}